import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { EditConversationPayload } from '@sdk/messages/types/apiTypes';

import { mapEditedConversation } from '@web/conversations/utils/mappers';
import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useUpdateConversation = () => {
  const { updateConversation } = useConversationQueryCache();
  const { conversation } = useSlingApi();

  const mutation = useMutation({
    mutationFn: async (payload: EditConversationPayload) => {
      const { data } = await conversation.edit(payload);
      const editedConversation = mapEditedConversation(data);

      return editedConversation;
    },
    onSuccess: (editedConversation, payload) => {
      updateConversation(payload.id, editedConversation);
    },
  });

  return mutation;
};
